<!-- <template>
  <div class="sh-bread">
    <slot />
       <div class="sh-bread-item">
      <RouterLink to="/">首页</RouterLink>
    </div>
    <i class="iconfont icon-angle-right"></i>
    <div class="xtx-bread-item" v-if="parentName">
      <RouterLink v-if="parentPath" :to="parentPath">{{
        parentName
      }}</RouterLink>
      <span v-else>{{ parentName }}</span>
    </div>
    <i v-if="parentName" class="iconfont icon-angle-right"></i>
    <div class="sh-bread-item">
    </div>
    <div class="sh-bread-item">
      <span><slot /></span>
    </div>
  </div>
</template> -->

<script>
import { h } from "vue";
export default {
  name: "ShBread",
  render() {
    //拿到sh-bread-items里面的node节点
    const items = this.$slots.default();

    const dymanicItems = [];
    //遍历拿到sh-bread-items里面的node节点并且删除最后一个元素里面的>箭头
    items.forEach((element, i) => {
      dymanicItems.push(element);
      /* if (i < element.length - 1) {
        //阿里图标库 >向右的箭头
        dymanicItems.push(h("i", { class: "iconfont icon-angle-right" }));
      } */
    });
    //h第一个参数为标签名字 第二个参数为属性对象 第三个为 子节点
    return h("div", { class: "sh-bread" }, dymanicItems);
  },
  /* props: {
    parentName: {
      type: String,
      default: "",
    },
    parentPath: {
      type: String,
      default: "",
    },
  }, */
};
</script>

<style lang="less">
//此处需要去掉scoped，以让其格式影响sh-bread-item组件
.sh-bread {
  display: flex;
  align-items: center;
  width: 1240px;
  margin: 0 auto;
  height: 50px;
  background-color: @shColor;
  line-height: 50px;
  font-size: 20px;
  &-item {
    display: flex;
    align-items: center;
    span {
      color: #ffffff;
      transition: all 0.4s;
    }
    a {
      color: #ffffff;
      transition: all 0.4s;
      &:hover {
        color: #cecccc;
      }
    }
    &:last-child{
      i{
        opacity:0;
        
      }
    }
  }
  i {
    color: #ffffff;
    font-size: 24px;
    margin-left: 5px;
    margin-right: 5px;
    transition: all 0.5s;
  }
  
  /*  :last-of-type{
    i{
      display: none;
    }
  } */
}
</style>
